import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class ImportPassengerUsersCommand extends IRequestCommand<
  IImportPassengerUsersResponse,
  ErrorDetails,
  FormData
  > {

  public override setParameters(passengerUserParameter: FormData) {
    this._commandType = CommandRequestType.POST;
    this._commandUrl = `passengers/import/${passengerUserParameter.get('carrier')}`;
    this._commandBody = passengerUserParameter;
  }
}

export interface IImportPassengerUsersResponse extends ICommandResponse {
  successLines: number,
  newClients: number,
  updateClients: number,
  errors: Array<IImportCSVError>,
  warnings: Array<IImportCSVError>
}

export interface IImportCSVError {
  warning: string,
  error: string,
  lineNumber: number,
  line: Object
}
